import * as React from 'react';
import { observer } from 'mobx-react';

import { AdvanceTable, IBasicTableColumn, DangerAlert } from 'ui-lib';
import { IDeviceTableProps } from './components';
import devicesCss from './devices.css';
import { DeviceTranferredFilesStore } from 'store/device-details/device-transferred-files.store';
import { TableUtils } from 'pages/private/components/table-utils';
import { useDeviceStore } from 'store';

export const TranferredFilesTable = observer((options: IDeviceTableProps) => {
    const devicesStore = useDeviceStore();
    const store = React.useMemo(
        () =>
            {
                const store = new DeviceTranferredFilesStore({
                    accountId: options.accountId,
                    uid: options.uid,
                    devicesStore: devicesStore,
                    serialNumber: options.serialNumber,
                });
                store.initialize();
                return store;
            },
        [],
    );

    const columns: IBasicTableColumn[] = [
        TableUtils.createBasicFilterColumn({ key: 'filePath', title: 'File Path' }),
        TableUtils.createBasicFilterColumn({ key: 'version', title: 'Version' }),
        TableUtils.createBasicFilterColumn({ key: 'status', title: 'Status' }),
        TableUtils.createBasicFilterTimeColumn({ key: 'updatedAt', title: 'Updated At' }),
    ];

    return (
        <div className={devicesCss.tabPane}>
            {store.error != undefined && <DangerAlert closable={false} message='Error' description={store.error} />}
            <AdvanceTable
                title=''
                table={{ columns, dataSource: store.currentTranferredFilesListing, rowKey: 'filePath' }}
                loadingState={store.loading}
                toolbar={{
                    onReload: (): Promise<void> => store.fetchLatestData(),
                }}
            />
        </div>
    );
});
